import styled from 'styled-components'
import { InfoCircleIcon } from '@shipt/design-system-icons'
import { TransparentButton } from '@/features/shared/elements/Buttons'

type InfoButtonProps = {
  onClick: (e: React.MouseEvent) => void
}

export const InfoButton = ({ onClick, ...restProps }: InfoButtonProps) => (
  <Button onClick={onClick} {...restProps}>
    <InfoCircleIcon size="sm" />
  </Button>
)

const Button = styled(TransparentButton)`
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  margin-left: 0.5rem;
`
